var map = {
	"./EE/en-EE": 16058,
	"./EE/en-EE.json": 16058,
	"./EE/et-EE": 78688,
	"./EE/et-EE.json": 78688,
	"./EG/en-EG": 32546,
	"./EG/en-EG.json": 32546,
	"./KE/en-KE": 35270,
	"./KE/en-KE.json": 35270,
	"./LV/en-LV": 42390,
	"./LV/en-LV.json": 42390,
	"./LV/lv-LV": 31065,
	"./LV/lv-LV.json": 31065,
	"./ZA/en-ZA": 97842,
	"./ZA/en-ZA.json": 97842
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 92989;